import axios from "axios";
import ApiService from "../api.services";
import { TokenService } from "../auth/storage.services";

const InvoiceReturnServices = {
  add: async function (formData) {
    try {
      return await ApiService.postUploadData("/api/invoice-return", formData);
    } catch (error) {
      throw error;
    }
  },
};

export default InvoiceReturnServices;

export { InvoiceReturnServices };
